import {Component, ElementRef, Input} from '@angular/core';
import {WebsiteSpotPage} from '../../website-spot';

@Component({
    selector: 'hc-logado',
    templateUrl: 'hc-logado.html',
    providers: []
})
export class HcLogado {

    @Input('hpage') hpage: WebsiteSpotPage;
    @Input('blocked') blocked: any;
    @Input('index') index: number;
    @Input('first') first: boolean;

    constructor(public element: ElementRef) {

    }

    styleWrap() {

        let padtop = this.hpage.platenode(this.blocked, 'Header', 'Molded', 'Padtop') + 'px';
        let padbot = this.hpage.platenode(this.blocked, 'Header', 'Molded', 'Padbot') + 'px';

        let style = {};

        let molde = this.hpage.platenode(this.blocked, 'Resume', 'Molded', 'Source');
        if (molde) style = {'background': 'url(' + molde + ') no-repeat scroll center top', 'padding-top': padtop, 'padding-bottom': padbot};

        return style;

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/website-spot/components/hc-logado/hc-logado.ts